import { FourUpCopyCard } from '@/design-system/atoms/Cards/FourUpCopyCard';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

const IntegrationFourUpCopyCard = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);
    const theme = modifiers.theme;
    const mediaShape = modifiers.imageShape;

    const image = props.image?.image
        ? {
              ...props.image.image,
              width: props.image.width || props.image.image.width,
              height: props.image.height || props.image.image.height,
          }
        : props.image;

    return <FourUpCopyCard {...props} image={image} theme={theme} mediaShape={mediaShape} />;
};

export default IntegrationFourUpCopyCard;
